export default "__VITE_ASSET__BU7h6A9G__"